import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function MidPageCTA() {
  const smoothScrollTo = (elementId: string) => {
    const target = document.getElementById(elementId);
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 1200;
    let startTime: number | null = null;
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const animation = (currentTime: number) => {
      if (startTime === null) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, startPosition + distance * easeInOutCubic(progress));
      if (elapsed < duration) requestAnimationFrame(animation);
    };
    requestAnimationFrame(animation);
  };
  return <section className="py-16 px-4 bg-[#0B0E13] text-[#F5F0E8] relative overflow-hidden" data-id="element-145">
      <div className="absolute inset-0 bg-gradient-to-r from-[#D4A843]/5 via-transparent to-[#D4A843]/5 pointer-events-none" data-id="element-146" />
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-2xl mx-auto text-center relative z-10" data-id="element-147">
        <div className="w-16 h-px bg-[#D4A843] mx-auto mb-8" data-id="element-148" />
        <p className="text-xl md:text-2xl font-serif font-bold mb-6" data-id="element-149">
          Protege tu compra antes de que sea tarde.
        </p>
        <button onClick={() => smoothScrollTo('pricing')} className="group px-8 py-4 bg-[#D4A843] hover:bg-[#E8BC5A] text-[#0B0E13] font-bold text-lg rounded-lg transition-all duration-300 shadow-[0_0_20px_rgba(212,168,67,0.3)] hover:shadow-[0_0_30px_rgba(212,168,67,0.5)] inline-flex items-center" data-id="element-150">
          <span data-id="element-151">Quiero el Kit — $6.36</span>
          <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-152" />
        </button>
        <div className="w-16 h-px bg-[#D4A843] mx-auto mt-8" data-id="element-153" />
      </motion.div>
    </section>;
}